export const defaultProductUi = {
  minusDisabled: true,
  plusDisabled: false,
  quantity: 1,
  canAddMore: true,
  fullPrice: 0.00,
  isOnSale: false,
  salePrice: 0.00,
  percentSavings: 0,
  backorder: null, 
  errors: [],
};


export function formatBackorderMessage(requestedQuantity, availableQuantity, productAllowsBackordering = false, isDownloadable = false) {
  const desiredQuantity = parseInt(requestedQuantity, 10);
  const currentQuantity = parseInt(availableQuantity, 10);

  if (isNaN(desiredQuantity) || isNaN(currentQuantity)) {
    return null;
  }

  const backorderQuantityNeeded = desiredQuantity - currentQuantity;
  // Show backorder message if: allows backordering AND not digital is on backorder
  if (productAllowsBackordering && !isDownloadable && backorderQuantityNeeded > 0) {
    return backorderQuantityNeeded + window.gettext(" on backorder");
  } 

  return null;
}


export function updateProductUi(product, newQuantity, productUi) {
  const {
    price, 
    current_price,
    retail_price, 
    quantity_break_ranges, 
    quantity, 
    quantity_in_cart, 
    quantity_break_prices,
    maximum_quantity,
    minimum_quantity,
    backordering,
    downloadable
  } = product;
  
  const parsedQuantity = parseInt(newQuantity, 10); 
  let backorder;
  let percentSavings = 0;
  let isDiscountedFromRetail = false;
  let salePrice = parseFloat(current_price || price);
  let fullPrice = parseFloat(retail_price || price);

  if (quantity_break_ranges && quantity_break_ranges.length > 0) {
    for (let i = 0; i < quantity_break_ranges.length; i++) {
      const range = quantity_break_ranges[i].split("-");
      const lowerBound = parseInt(range[0], 10);
      const upperBound = parseInt(range[1], 10);
      if (
        (parsedQuantity >= lowerBound && parsedQuantity <= upperBound) ||
        (parsedQuantity >= lowerBound && isNaN(upperBound))
      ) {
        salePrice = parseFloat(quantity_break_prices[i]);
        break;
      }
    }
  }
// product.manage_stock is False if a product is backorderable, on_demand, or downloadable.
  // Use a default product type if not available
  backorder = formatBackorderMessage(parsedQuantity + quantity_in_cart, quantity, backordering, downloadable);

  // calculate % savings for display (keep salePrice/fullPrice numeric until formatting for JSX)
  if (fullPrice > salePrice) {
    percentSavings = Math.round(((fullPrice - salePrice) / fullPrice) * 100);
    isDiscountedFromRetail = true;
  }

  // Calculate max_remaining safely
  const maxRemaining = maximum_quantity !== null ? Math.max(maximum_quantity - quantity_in_cart, 0) : null;

  return {
    ...productUi,
    quantity: parseInt(newQuantity),
    minusDisabled: parsedQuantity <= (minimum_quantity || 1),
    backorder: backorder,
    isDiscountedFromRetail: isDiscountedFromRetail,
    plusDisabled: (maximum_quantity !== null) && (parsedQuantity >= maxRemaining),
    canAddMore: maximum_quantity === null || maxRemaining > 0,
    cleanSalePrice: salePrice.toFixed(2),
    cleanFullPrice: fullPrice.toFixed(2),
    percentSavings: percentSavings,
  }
}

